import styled from "@emotion/styled";
import { CountryCodeWrapperProps } from "./CountryCodeInput.types";
import { getCountryCodeStyles } from "../../utils";
import { colorPalette } from "../../theme/colors";
import PhoneInputWithCountry from "react-phone-number-input";
import "react-phone-number-input/style.css";

export const CountryCodeWrapper = styled.div<CountryCodeWrapperProps>`
  width: fit-content;
  display: flex;
  padding-left: 8px;
  border-radius: 10px;
  position: relative;
  width: 100px;
  height: ${(props) => props.height || "100%"};
  align-items: center;
  box-sizing: border-box;
  ${(props) => getCountryCodeStyles(props)}
`;
export const ChevronDropdownIcon = styled.i`
  position: absolute;
  right: 12px;
  font-size: 16px;
  color: ${colorPalette.success[500]};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const PhoneInputStyled = styled(PhoneInputWithCountry as any)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  border: none;
  background: transparent;

  .PhoneInput {
    height: 100%;
  }

  input {
    border: none;
    outline: none;
    background: transparent;
    height: 100%;
    font-family: "Rubik", sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #000;
    letter-spacing: 0.2px;
  }
  .PhoneInputCountrySelectArrow {
    display: none;
  }

  .PhoneInputCountryIcon {
    width: 14px;
    height: 20px;
    overflow: hidden;
  }
  .PhoneInputCountryIcon--border {
    background-color: transparent !important;
    box-shadow: none !important;
  }
  && .PhoneInputCountrySelect {
    width: 5.2rem !important;
    min-width: 5.2rem !important;
    max-width: 6.2rem !important;
  }
`;
